export const players = [
  {
    id: 'p-2301',
    name: '张镇麟',
    enName: 'Zhang Zhenlin',
    teamId: 'cba-liaoning',
    position: '小前锋',
    number: 33,
    age: 27,
    height: '2.06 米',
    weight: '105 公斤',
    country: '中国',
    ppg: 21.4,
    rpg: 6.8,
    apg: 3.9,
    spg: 1.4,
    bpg: 0.8,
    fg: '48.6%',
    gamesPlayed: 46,
    trend: [
      { label: '第1场', value: 18 },
      { label: '第2场', value: 24 },
      { label: '第3场', value: 16 },
      { label: '第4场', value: 29 },
      { label: '第5场', value: 22 },
      { label: '第6场', value: 27 },
      { label: '第7场', value: 31 },
    ],
    intro: '辽宁队锋线核心，身体条件出色，突破与中距离投篮稳定，是国内最具竞争力的三号位球员之一。',
  },
  {
    id: 'p-2302',
    name: '赵继伟',
    enName: 'Zhao Jiwei',
    teamId: 'cba-liaoning',
    position: '控球后卫',
    number: 3,
    age: 31,
    height: '1.85 米',
    weight: '80 公斤',
    country: '中国',
    ppg: 14.2,
    rpg: 3.1,
    apg: 8.6,
    spg: 2.0,
    bpg: 0.2,
    fg: '45.2%',
    gamesPlayed: 44,
    trend: [
      { label: '第1场', value: 12 },
      { label: '第2场', value: 9 },
      { label: '第3场', value: 18 },
      { label: '第4场', value: 15 },
      { label: '第5场', value: 11 },
      { label: '第6场', value: 20 },
      { label: '第7场', value: 14 },
    ],
    intro: '球队大脑，传球视野开阔，节奏掌控能力极强，多次在关键比赛中送出致命助攻。',
  },
  {
    id: 'p-2303',
    name: '胡明轩',
    enName: 'Hu Mingxuan',
    teamId: 'cba-guangdong',
    position: '得分后卫',
    number: 24,
    age: 28,
    height: '1.91 米',
    weight: '82 公斤',
    country: '中国',
    ppg: 17.5,
    rpg: 3.4,
    apg: 4.2,
    spg: 1.6,
    bpg: 0.3,
    fg: '46.8%',
    gamesPlayed: 43,
    trend: [
      { label: '第1场', value: 15 },
      { label: '第2场', value: 21 },
      { label: '第3场', value: 19 },
      { label: '第4场', value: 13 },
      { label: '第5场', value: 24 },
      { label: '第6场', value: 18 },
      { label: '第7场', value: 16 },
    ],
    intro: '广东队外线主力，三分投射与无球跑动出色，攻防转换中极具威胁。',
  },
  {
    id: 'p-2304',
    name: '周琦',
    enName: 'Zhou Qi',
    teamId: 'cba-guangdong',
    position: '中锋',
    number: 21,
    age: 30,
    height: '2.17 米',
    weight: '113 公斤',
    country: '中国',
    ppg: 18.9,
    rpg: 11.2,
    apg: 2.4,
    spg: 0.9,
    bpg: 2.7,
    fg: '53.1%',
    gamesPlayed: 41,
    trend: [
      { label: '第1场', value: 22 },
      { label: '第2场', value: 16 },
      { label: '第3场', value: 19 },
      { label: '第4场', value: 25 },
      { label: '第5场', value: 17 },
      { label: '第6场', value: 20 },
      { label: '第7场', value: 23 },
    ],
    intro: '国内顶级内线，护框能力突出，进攻端具备中远距离投射，是球队攻防两端的支柱。',
  },
  {
    id: 'p-2305',
    name: '勒布朗·詹姆斯',
    enName: 'LeBron James',
    teamId: 'nba-lakers',
    position: '小前锋',
    number: 23,
    age: 41,
    height: '2.06 米',
    weight: '113 公斤',
    country: '美国',
    ppg: 24.8,
    rpg: 7.6,
    apg: 8.1,
    spg: 1.3,
    bpg: 0.6,
    fg: '50.4%',
    gamesPlayed: 58,
    trend: [
      { label: '第1场', value: 26 },
      { label: '第2场', value: 22 },
      { label: '第3场', value: 31 },
      { label: '第4场', value: 19 },
      { label: '第5场', value: 28 },
      { label: '第6场', value: 24 },
      { label: '第7场', value: 27 },
    ],
    intro: '联盟常青树，全面的得分与组织能力兼具，关键时刻的统治力依旧惊人。',
  },
  {
    id: 'p-2306',
    name: '安东尼·戴维斯',
    enName: 'Anthony Davis',
    teamId: 'nba-lakers',
    position: '大前锋',
    number: 3,
    age: 33,
    height: '2.08 米',
    weight: '115 公斤',
    country: '美国',
    ppg: 25.1,
    rpg: 12.3,
    apg: 3.2,
    spg: 1.2,
    bpg: 2.4,
    fg: '54.2%',
    gamesPlayed: 52,
    trend: [
      { label: '第1场', value: 28 },
      { label: '第2场', value: 21 },
      { label: '第3场', value: 30 },
      { label: '第4场', value: 24 },
      { label: '第5场', value: 26 },
      { label: '第6场', value: 19 },
      { label: '第7场', value: 33 },
    ],
    intro: '攻防兼备的顶级内线，盖帽与篮板能力出众，中距离投篮同样稳定可靠。',
  },
  {
    id: 'p-2307',
    name: '斯蒂芬·库里',
    enName: 'Stephen Curry',
    teamId: 'nba-warriors',
    position: '控球后卫',
    number: 30,
    age: 38,
    height: '1.88 米',
    weight: '84 公斤',
    country: '美国',
    ppg: 27.6,
    rpg: 4.5,
    apg: 6.3,
    spg: 1.1,
    bpg: 0.3,
    fg: '47.9%',
    gamesPlayed: 56,
    trend: [
      { label: '第1场', value: 32 },
      { label: '第2场', value: 25 },
      { label: '第3场', value: 29 },
      { label: '第4场', value: 21 },
      { label: '第5场', value: 35 },
      { label: '第6场', value: 26 },
      { label: '第7场', value: 28 },
    ],
    intro: '历史级三分射手，超远投射与无球跑动改变现代篮球打法，是勇士体系的绝对核心。',
  },
  {
    id: 'p-2308',
    name: '杰森·塔图姆',
    enName: 'Jayson Tatum',
    teamId: 'nba-celtics',
    position: '小前锋',
    number: 0,
    age: 28,
    height: '2.03 米',
    weight: '95 公斤',
    country: '美国',
    ppg: 28.2,
    rpg: 8.4,
    apg: 4.8,
    spg: 1.0,
    bpg: 0.7,
    fg: '47.1%',
    gamesPlayed: 60,
    trend: [
      { label: '第1场', value: 30 },
      { label: '第2场', value: 27 },
      { label: '第3场', value: 33 },
      { label: '第4场', value: 22 },
      { label: '第5场', value: 29 },
      { label: '第6场', value: 31 },
      { label: '第7场', value: 25 },
    ],
    intro: '凯尔特人当家球星，中距离与三分投射俱佳，关键球能力持续进化。',
  },
  {
    id: 'p-2309',
    name: '尼古拉·约基奇',
    enName: 'Nikola Jokic',
    teamId: 'nba-nuggets',
    position: '中锋',
    number: 15,
    age: 31,
    height: '2.11 米',
    weight: '129 公斤',
    country: '塞尔维亚',
    ppg: 26.4,
    rpg: 12.1,
    apg: 9.3,
    spg: 1.3,
    bpg: 0.9,
    fg: '57.6%',
    gamesPlayed: 58,
    trend: [
      { label: '第1场', value: 24 },
      { label: '第2场', value: 28 },
      { label: '第3场', value: 22 },
      { label: '第4场', value: 30 },
      { label: '第5场', value: 26 },
      { label: '第6场', value: 23 },
      { label: '第7场', value: 29 },
    ],
    intro: '以传球视野著称的组织型中锋，低位技术与篮球智商顶级，多次获得常规赛最有价值球员。',
  },
  {
    id: 'p-2310',
    name: '阿贾·威尔逊',
    enName: 'A\'ja Wilson',
    teamId: 'wnba-aces',
    position: '大前锋',
    number: 22,
    age: 30,
    height: '1.93 米',
    weight: '88 公斤',
    country: '美国',
    ppg: 26.9,
    rpg: 10.4,
    apg: 2.8,
    spg: 1.4,
    bpg: 2.6,
    fg: '52.8%',
    gamesPlayed: 38,
    trend: [
      { label: '第1场', value: 28 },
      { label: '第2场', value: 24 },
      { label: '第3场', value: 31 },
      { label: '第4场', value: 27 },
      { label: '第5场', value: 22 },
      { label: '第6场', value: 29 },
      { label: '第7场', value: 26 },
    ],
    intro: 'WNBA 现役最具统治力的球员之一，得分与防守能力兼备，多次荣膺最有价值球员。',
  },
  {
    id: 'p-2311',
    name: '坎宁安',
    enName: 'Cade Cunningham',
    teamId: 'nba-mavericks',
    position: '控球后卫',
    number: 2,
    age: 25,
    height: '1.98 米',
    weight: '100 公斤',
    country: '美国',
    ppg: 23.7,
    rpg: 5.6,
    apg: 7.9,
    spg: 1.2,
    bpg: 0.5,
    fg: '45.8%',
    gamesPlayed: 55,
    trend: [
      { label: '第1场', value: 22 },
      { label: '第2场', value: 26 },
      { label: '第3场', value: 19 },
      { label: '第4场', value: 28 },
      { label: '第5场', value: 24 },
      { label: '第6场', value: 21 },
      { label: '第7场', value: 25 },
    ],
    intro: '高大控卫，组织与得分能力均衡，挡拆处理球成熟，是球队未来的建队核心。',
  },
  {
    id: 'p-2312',
    name: '扬尼斯·阿德托昆博',
    enName: 'Giannis Antetokounmpo',
    teamId: 'nba-bucks',
    position: '大前锋',
    number: 34,
    age: 32,
    height: '2.11 米',
    weight: '110 公斤',
    country: '希腊',
    ppg: 30.1,
    rpg: 11.8,
    apg: 5.9,
    spg: 1.1,
    bpg: 1.4,
    fg: '55.4%',
    gamesPlayed: 57,
    trend: [
      { label: '第1场', value: 33 },
      { label: '第2场', value: 28 },
      { label: '第3场', value: 31 },
      { label: '第4场', value: 26 },
      { label: '第5场', value: 35 },
      { label: '第6场', value: 29 },
      { label: '第7场', value: 30 },
    ],
    intro: '攻防一体的超级巨星，冲击力与运动能力顶级，转换进攻中几乎无法阻挡。',
  },
];